/*
 *
 * BillingConfiguration constants
 *
 */

export const BASE_ACTION_CONSTANT = 'app/BillingConfiguration';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const GET_ALL_SETTLEMENTS_RATES = `${BASE_ACTION_CONSTANT}/GET_ALL_SETTLEMENTS_RATES`;

export const CREATE_SETTLEMENTS_RATES = `${BASE_ACTION_CONSTANT}/CREATE_SETTLEMENTS_RATES`;

export const GET_ALL_SETTLEMENTS_RATES_URL = {
  url: '/pg/settlements/split/vendors/rates',
  method: 'GET',
};

export const APPROVED_RATE_STATUS = 'APPROVED';

export const RATE_TYPE = {
  TRANSACTION: 'TRANSACTION',
  SETTLEMENT: 'SETTLEMENT',
  VENDOR_OD: 'VENDOR_OD',
};

export const PAYLOAD_KEYS = [
  'rateType',
  'billingTo',
  'isPostPaid',
  'floor',
  'ceil',
  'fixedFee',
  'tdr',
  'adminId',
];

export const CREATE_SETTLEMENTS_RATES_URL = {
  url: '/pg/settlements/split/vendors/rates',
  method: 'POST',
};

export const UPDATE_ALL_SETTLEMENTS_RATES_URL = {
  url: '/pg/settlements/split/settlement-rates/bulk',
  method: 'POST',
};

export const BILLING_OPTIONS = [
  {
    label: 'Debit my Account',
    value: 'MERCHANT',
  },
  {
    label: 'Debit Vendor Account',
    value: 'VENDOR',
  },
];
